import { render } from "./PopupAvatarTerms.vue?vue&type=template&id=23ca759e"
import script from "./PopupAvatarTerms.vue?vue&type=script&lang=js"
export * from "./PopupAvatarTerms.vue?vue&type=script&lang=js"

import "./PopupAvatarTerms.vue?vue&type=style&index=0&id=23ca759e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__